import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import ImageUploader from '../ImageUploader/ImageUploader'
import { reExportedColors, Text } from '../../1elements'
import CancelIconButton from '../../1elements/Buttons/IconButtons/CancelIconButton/CancelIconButton'
import ImageUploadButton from '../../1elements/Buttons/TextButtons/ImageUploadButton/ImageUploadButton'
import { englishTexts } from '../../../consts/Texts'
import useImageUpload from '../../../services/customHooks/useImageUpload'

const AvatarUploader = ({ imageFile, setImageFile }) => {
  const theme = useTheme()
  const [error, setError] = useState('')
  const { getInputProps, open } = useImageUpload(setImageFile, 200 * 1000, setError)
  const instructionStyle = {
    color: theme.palette.tertiary.accent,
    textAlign: 'center'
  }

  return (
    <div>
      {imageFile
        ? (
          <Box sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '290px',
            position: 'relative',
            width: '220px'
          }}>
            <input {...getInputProps()} />
            <Box sx={{ position: 'absolute', right: '10px', top: '10px' }}>
              <CancelIconButton onClick={() => setImageFile(null)} />
            </Box>
            <Box
              component='img'
              alt=''
              src={imageFile[0].preview}
              onLoad={() => { URL.revokeObjectURL(imageFile[0].preview) }}
              sx={{
                borderRadius: '50%',
                height: '190px',
                objectFit: 'cover',
                width: '190px'
              }}
            />
            <Box sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              marginTop: '10px',
              '& > *': { marginTop: '5px' }
            }}>
              <ImageUploadButton onClick={open} />
              <Text type='h6' style={instructionStyle}>
                {englishTexts.imageUploader.finePrint}
              </Text>
              <Text type='h6' style={{ color: reExportedColors.RED }}>
                {error}
              </Text>
            </Box>
          </Box>
          )
        : (
          <ImageUploader
            imageFile={imageFile}
            setImageFile={setImageFile}
            sx={{
              borderRadius: '50%',
              height: '220px',
              objectFit: 'cover',
              width: '220px'
            }}
          />
          )}
    </div>
  )
}

export default AvatarUploader
